module.exports = __webpack_public_path__ + "img/7.b4ed2999.jpg";